import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { GlobalFiltersHelperService } from '../../data-access/services/global-filters-helper.service';
import { Observable } from 'rxjs';
import { HierarchyEntity } from '@ex/module/core/data-models/hierarcy-entity';
import { debounceTime, tap } from 'rxjs/operators';
import { FilterValue, GlobalCriteria } from '../../data-access/models/models';

@Component({
  selector: 'global-filters-bar',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.scss']
})
export class FiltersBarComponent extends BaseComponent implements OnInit {
  @Input() showFilterButton: boolean = true;
  @Input() language: string = 'EN';
  @Input() legacy: boolean = true;
  @Output() open: EventEmitter<boolean> = new EventEmitter();
  @Output() filters: EventEmitter<FilterValue[]> = new EventEmitter();
  @Input() hasFilters: boolean = false;
  @Output() hasFiltersChange: EventEmitter<boolean> = new EventEmitter();
  barFilters$: Observable<{ entities: HierarchyEntity[], filters: GlobalCriteria[] }>;
  constructor(private globalFilterHelper: GlobalFiltersHelperService) {
    super();
  }
  ngOnInit(): void {
    this.globalFilterHelper.clearFilters();
    this.barFilters$ = this.globalFilterHelper.generateBarFilters().pipe(tap(filters => {
      this.hasFilters = filters.filters?.length > 0 || filters.entities?.length > 0;
      this.hasFiltersChange.emit(this.hasFilters);

      return filters;
    }));
    this.addSubscription(this.globalFilterHelper.combinedFilters().pipe(debounceTime(100)).subscribe(({ filters }) => {
      if (this.globalFilterHelper.applyFilters$.value) {
        this.filters.emit(filters);
      }

    }));
    // this.globalFilterHelper.removeFilters();
  }
  resetFilters() {
    this.globalFilterHelper.resetAllFilters();
  }
  openFilters() {
    this.open.emit(true);
  }

  removeGroupFilter(groupKey: string) {
    this.globalFilterHelper.resetEntityGroup(groupKey)
  }
  removeFilter(key) {
    this.globalFilterHelper.removeFilters(key)
  }


}
